import { ComponentProps, useEffect } from 'react';
import { ImageSection } from '@weave/schema-gen-ts/dist/schemas/messaging/shared/v1/composer.pb';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { RadioField } from '@frontend/design-system';
import { useComposerSection } from '../hooks/use-composer-section';
import { Setting } from './setting';
import { getRadioOptionStyles, radioFieldStyles } from './styles';

type CountSettingProps = ComponentProps<typeof RadioField>;

export const CountSetting = (props: CountSettingProps) => {
  const { t } = useTranslation('content-composer');
  const { setProps } = useComposerSection<ImageSection>();

  useEffect(() => {
    setProps((data) => {
      const count = parseInt(props.value || '1');
      data.imageCount = count;

      const newImages = data.images || [];
      switch (count) {
        case 1:
          newImages.splice(1);
          break;
        case 2:
          newImages.splice(2);
          break;
        case 3:
        default:
          break;
      }

      data.images = newImages;
    });
  }, [props.value, setProps]);

  return (
    <Setting title={t('Layout')}>
      <RadioField {...props} css={radioFieldStyles}>
        <CountRadioField count='1' selectedValue={props.value} />
        <CountRadioField count='2' selectedValue={props.value} />
        <CountRadioField count='3' selectedValue={props.value} />
      </RadioField>
    </Setting>
  );
};

type CountRadioFieldProps = {
  count: string;
  selectedValue: string;
};

const CountRadioField = ({ count, selectedValue }: CountRadioFieldProps) => {
  return (
    <RadioField.Radio value={count} className='hide-radio' css={getRadioOptionStyles(selectedValue === count)}>
      <div
        css={{
          display: 'flex',
        }}
      >
        {Array.from({ length: parseInt(count, 10) }).map((_, index) => (
          <span
            key={index}
            css={{
              display: 'inline-block',
              width: theme.spacing(1.75),
              height: theme.spacing(2.5),
              background: theme.colors.neutral90,
              borderRadius: theme.borderRadius.small,
              '&:not(:last-of-type)': {
                marginRight: theme.spacing(0.5),
              },
            }}
          />
        ))}
      </div>
    </RadioField.Radio>
  );
};
